import { useEffect } from 'react';

import type { UniqueScrollRequestId } from './scrollIntoViewTypes';

/**
 * Scrolls an element into view when `uniqueScrollRequestId` becomes truthy or changes. A changing id
 * rather than a boolean is what lets an already-scrolled section be scrolled to *again*.
 *
 * Duplicates `activities-desking/src/utils/useScrollIntoView` deliberately: that package already
 * imports `dr-dash-components`, so importing back would be a cycle `check:circular` rejects. It lives
 * here beside `buildUniqueScrollRequestId`.
 */
export const useScrollIntoView = (ref: React.RefObject<HTMLDivElement>, uniqueScrollRequestId: UniqueScrollRequestId): void => {
    useEffect(() => {
        if (uniqueScrollRequestId && ref?.current?.scrollIntoView) {
            ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        // Keyed on the id alone: keying on the ref would scroll on unrelated re-renders.
    }, [uniqueScrollRequestId]);
};
